<article class="block-wysiwyg container section-outset-y">
  <div class="block-wysiwyg__content text-max-width-sm mx-auto">
    <h2 *ngIf="block.title" [innerHTML]="block.title | highlight" class="splitting splitting--word-in" data-split></h2>

    <div
      class="markdown-content anim-fade-up delay--1"
      [class.anim--active]="inviewPort"
      fstrDynamicContent
      [innerHTML]="block.text || '' | resizeHtmlImages | stripEmbed : cookiePreferences | safe"
    ></div>
  </div>
</article>
